import { render, staticRenderFns } from "./DatosGeneralesForm.vue?vue&type=template&id=56434026&scoped=true"
import script from "./DatosGeneralesForm.vue?vue&type=script&lang=js"
export * from "./DatosGeneralesForm.vue?vue&type=script&lang=js"
import style0 from "./DatosGeneralesForm.vue?vue&type=style&index=0&id=56434026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56434026",
  null
  
)

export default component.exports